"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _reactTracking = require("react-tracking");

var _stitches = require("../../../stitches.config");

var _wizardsSlice = require("../../../store/wizardsSlice");

var _Checkbox = require("../../input/checkbox/Checkbox");

var _ImageOrLottie = _interopRequireDefault(require("../image-or-lottie/ImageOrLottie"));

var _sharedStyles = require("../sharedStyles");

var StyledQuestion = (0, _stitches.styled)('div', {
  marginLeft: 'auto',
  marginRight: 'auto',
  maxWidth: '500px',
  textAlign: 'center'
});
var ChoicesGrid = (0, _stitches.styled)('div', {
  display: 'flex',
  flex: '50%'
});
var ChoicesContainer = (0, _stitches.styled)('div', {
  display: 'flex',
  flexFlow: 'wrap',
  justifyContent: 'space-around',
  marginLeft: 'auto',
  marginRight: 'auto',
  marginTop: '10px',
  width: '310px',
  '@tablet': {
    width: '460px',
    justifyContent: 'center'
  }
});
var Choice = (0, _stitches.styled)('div', {
  backgroundColor: '$white',
  position: 'relative',
  textAlign: 'center',
  width: '150px',
  letterSpacing: '0',
  margin: '2px',
  '&:hover': {
    cursor: 'pointer'
  },
  div: {
    overflowWrap: 'break-word'
  },
  input: {
    left: 0,
    position: 'absolute',
    // unset sfcc styles
    fontSize: 'unset',
    opacity: 'unset',
    padding: 'unset',
    textIndent: 'unset',
    width: 'unset'
  },
  variants: {
    selected: {
      true: {
        outline: '2px solid $secondary',
        padding: '0'
      }
    }
  }
});
var ChoiceTitle = (0, _stitches.styled)('div', {
  fontWeight: '$semiBold'
});
/**
 * A question with small images as selections for answers.
 * Displayed in rows of 3 for mobile and rows of 4 for desktop.
 * This is always multi-select.
 */

var ImageQuestion = function ImageQuestion(_ref) {
  var answer = _ref.answer,
      answers = _ref.answers,
      choices = _ref.choices,
      id = _ref.id,
      isCheckBox = _ref.isCheckBox,
      isSingleSelect = _ref.isSingleSelect,
      onNext = _ref.onNext,
      subtitle = _ref.subtitle,
      title = _ref.title,
      currentStepIndex = _ref.currentStepIndex,
      category = _ref.category,
      quizPercentage = _ref.quizPercentage;
  var dispatch = (0, _reactRedux.useDispatch)();

  var _useTracking = (0, _reactTracking.useTracking)(),
      trackEvent = _useTracking.trackEvent;

  var handleAnswerSelect = function handleAnswerSelect(choiceValue) {
    dispatch((0, _wizardsSlice.setAnswer)({
      answer: choiceValue,
      questionPath: id
    }));
  };

  var handleKeyboardEvent = function handleKeyboardEvent(choiceValue, event) {
    if (!isCheckBox && event.key === 'Enter') {
      handleAnswerSelect(choiceValue);
    }
  };

  var isChoiceSelected = function isChoiceSelected(choiceValue) {
    if (isSingleSelect) {
      return answer === choiceValue;
    }

    return answers.includes(choiceValue);
  };

  var ChoicesGridCss = function ChoicesGridCss(elem, index) {
    var divElements = index + 1;

    if (elem - divElements == 0 && divElements % 2 !== 0) {
      return {
        justifyContent: 'center'
      };
    }

    if (divElements % 2 == 0) {
      return {
        justifyContent: 'flex-start'
      };
    }

    return {
      justifyContent: 'flex-end'
    };
  };

  return /*#__PURE__*/_react.default.createElement(StyledQuestion, null, /*#__PURE__*/_react.default.createElement(_sharedStyles.Title, null, title), /*#__PURE__*/_react.default.createElement("div", null, subtitle), /*#__PURE__*/_react.default.createElement(ChoicesContainer, null, choices.map(function (choice, index) {
    return /*#__PURE__*/_react.default.createElement(ChoicesGrid, {
      css: ChoicesGridCss(choices.length, index),
      key: choice.value
    }, /*#__PURE__*/_react.default.createElement(Choice, {
      "aria-checked": isChoiceSelected(choice.value),
      key: choice.value,
      role: "radio",
      selected: isChoiceSelected(choice.value),
      tabIndex: 0,
      onClick: function onClick() {
        return handleAnswerSelect(choice.value);
      },
      onKeyDown: function onKeyDown(event) {
        handleKeyboardEvent(choice.value, event);
      }
    }, isCheckBox && /*#__PURE__*/_react.default.createElement(_Checkbox.StyledCheckbox, {
      readOnly: true,
      checked: isChoiceSelected(choice.value),
      id: choice.value,
      name: choice.value,
      type: "checkbox"
    }), /*#__PURE__*/_react.default.createElement(_ImageOrLottie.default, Object.assign({
      css: {
        height: '110px',
        width: '100%'
      }
    }, choice.image)), /*#__PURE__*/_react.default.createElement(ChoiceTitle, null, choice.title), /*#__PURE__*/_react.default.createElement("div", null, choice.subtitle)));
  })));
};

ImageQuestion.defaultProps = {
  answer: '',
  answers: [],
  category: '',
  currentStepIndex: '',
  isCheckBox: '',
  isSingleSelect: false,
  onNext: function onNext() {},
  quizPercentage: '',
  subtitle: ''
};
var _default = ImageQuestion;
exports.default = _default;